module.exports = __webpack_public_path__ + "static/media/BMODE_4553e742-aa34-4042-ad0f-999ced82dcfe.cdca8378.jpg";